export default {
    navmenu: {
        padding: "0px 26px 32px 26px",
        color: "white",
        "& h2": {
            padding: "0px 0px 13px 0px",
            textTransform: "uppercase",
            fontSize: "14px",
            fontWeight: "500",
            fontStyle: "normal",
            fontStretch: "normal",
            lineHeight: "1.14",
            letterSpacing: "0.5px"
        },
        "& h4": {
            padding: "0px 26px 0px 13px",
            textTransform: "uppercase",
            fontSize: "14px",
            fontWeight: "500",
            fontStyle: "normal",
            opacity: "0.5",
            fontStretch: "normal",
            lineHeight: "1.14",
            letterSpacing: "0.5px"
        },

        "& ul": {
            listStyle: "none",
            margin: "25px 0",
            padding: "0",
            "& li": {
                padding:"0"
            }
        },
        "& button, & a": {
            backgroundColor: "transparent",
            color: "white",
            fontSize: "16px",
            fontStyle: "normal",
            fontStretch: "normal",
            fontWeight: "normal",
            lineHeight: "1.5",
            letterSpacing: "0.5px",
            border: "0",
            margin: "13px 0 13px 26px",
            padding:"0",
            textAlign: "left",
            display: "block",
            width: "100%",
            "&:hover": {
                textDecoration: "none"
            }
        },
        "@media (max-width: 1023px)": {
            "& button, & a": {
                margin: "13px 0 0 13px"
            },
            "& h2, & h4": {
                padding: "0"
            }
        }
    },

};